export default {
  data: (vm) => ({
    availableStatus: {
      'CERRADO': {
        color: 'green',
        textColor: 'white',
        label: vm.$i18n.t('closed'),
      },
      'CANCELED': {
        color: 'red',
        textColor: 'white',
        label: vm.$i18n.t('canceled'),
      },
      'CANCELADO': {
        color: 'red',
        textColor: 'white',
        label: vm.$i18n.t('canceled'),
      },
      'REGISTRADO_PEDIDO': {
        color: 'orange',
        textColor: 'white',
        label: vm.$i18n.t('booked'),
      },
      'EN ESPERA DE ENVÍO': {
        color: 'orange',
        textColor: 'white',
        label: vm.$i18n.t('orderPending'),
      },
      'EN ESPERA DE DEVOLUCIÓN': {
        color: 'orange',
        textColor: 'white',
        label: vm.$i18n.t('orderPending'),
      },
      'REGISTRADO': {
        color: 'orange',
        textColor: 'white',
        label: vm.$i18n.t('orderPending'),
      },
      'INGRESADO': {
        color: 'orange',
        textColor: 'white',
        label: vm.$i18n.t('orderPending'),
      },
      'PEDIDO PENDIENTE': {
        color: 'orange',
        textColor: 'white',
        label: vm.$i18n.t('orderPending'),
      },
      'LISTO PARA DESPACHO': {
        color: 'orange',
        textColor: 'white',
        label: vm.$i18n.t('orderPending'),
      },
      'SELECIONADO': {
        color: 'purple',
        textColor: 'white',
        label: vm.$i18n.t('inPreparation'),
      },
      'EN ETAPAS/CON SELECCIÓN CONFIRMADA': {
        color: 'purple',
        textColor: 'white',
        label: vm.$i18n.t('inPreparation'),
      },
      'ENVIADO': {
        color: 'purple',
        textColor: 'white',
        label: vm.$i18n.t('inPreparation'),
      },
    },
  }),
  methods: {
    getNewStatus(status) {
      if (!status) {
        return null
      }

      return this.availableStatus[status.toUpperCase()]
    }
  }
}